
export class Point {
public x: number;
public y: number;
/**
 * @param {?} x
 * @param {?} y
 */
constructor(x: number, y: number) {
    this.x = x;
    this.y  = y;
  }
}

function Point_tsickle_Closure_declarations() {
/** @type {?} */
Point.prototype.x;
/** @type {?} */
Point.prototype.y;
}
